import { ChangeEvent } from 'react';

interface IStyleCheckboxProps {
    isChecked: boolean;
    value: string;
    label: string;
    changeCallback: (id: string) => void;
    ga?: string;
}

export const StyleCheckbox = (props: IStyleCheckboxProps) => {
    const { isChecked, value, label, changeCallback, ga } = props || {};

    return <div className={`style-checkbox ${isChecked ? 'checked' : ''}`}>
        <label className="style-checkbox-label">
            <span className="style-checkbox-input">
                <input type="checkbox" value={value} 
                    checked={isChecked}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => { 
                        changeCallback(value); 
                    }}
                    {...(ga ? {['data-contents']: ga} : undefined)} />
            </span>
            <p className="style-checkbox-text">{label}</p>
        </label>
    </div>
}